import { useQuery } from "@tanstack/react-query"
import { discoverOutlookMailboxesQuery } from "modules/settings/lib/outlook/discoverOutlookMailboxesQuery"

export function useDiscoverOutlookMailboxesQuery(
  outlookAccountId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useQuery({
    ...discoverOutlookMailboxesQuery(outlookAccountId ?? ""),
    enabled: enabled && !!outlookAccountId,
  })
}
